export const activity = () => (
  <path
    d="M22 12h-4l-3 9L9 3l-3 9H2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
